import React from 'react';
import classnames from 'classnames';

export interface ListItemTextProps {
  tabIndex?: number;
  className?: string;
  primaryText?: React.ReactNode;
  secondaryText?: React.ReactNode;
  childrenTabIndex?: number;
}

// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/14064
function isReactElement(element: any): element is React.ReactElement<any> {
  return element !== null && element.props !== undefined;
}

const ListItemText: React.FunctionComponent<ListItemTextProps> = ({
  primaryText = '',
  secondaryText = '',
  tabIndex = -1,
  className = '',
  ...otherProps
}) => {
  const renderText = (text: React.ReactNode, className: string) => {
    if (text === undefined) return null;
    if (typeof text === 'string' || typeof text === 'number') {
      return (
        <span
          className={className}
          tabIndex={tabIndex !== undefined ? tabIndex : -1}
        >
          {text}
        </span>
      );
    }
    if (!isReactElement(text)) return null;

    const {className: textClassName, ...otherProps} = text.props;
    className = classnames(className, textClassName);
    const props = {...otherProps, className};

    return React.cloneElement(text, props);
  };

  if (!secondaryText) {
    return renderText(
      primaryText,
      classnames('mdc-list-item__text', className)
    );
  }

  return (
    <span
      className={classnames('mdc-list-item__text', className)}
      tabIndex={tabIndex !== undefined ? tabIndex : -1}
      {...otherProps}
    >
      {renderText(primaryText, 'mdc-list-item__primary-text')}
      {renderText(secondaryText, 'mdc-list-item__secondary-text')}
    </span>
  );
};

export default ListItemText;
